module.exports = __webpack_public_path__ + "img/logo-success.6f5af069.png";